import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useStoryStore } from '../../store/storyStore';

const ShakeEffect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const controls = useAnimation();
  const gameState = useStoryStore((state) => state.gameState);
  
  useEffect(() => {
    const shakeLevel = gameState['shake'] as number || 0;
    
    if (shakeLevel > 0) {
      // Create a randomized shake sequence
      const intensity = shakeLevel * 5;
      controls.start({
        x: [0, -intensity, intensity, -intensity, intensity, 0],
        y: [0, intensity/2, -intensity/2, intensity/2, -intensity/2, 0],
        transition: { 
          duration: 0.4, 
          repeat: Infinity,
          ease: "easeInOut" 
        }
      });
    } else {
      controls.stop();
      controls.set({ x: 0, y: 0 });
    }
  }, [gameState['shake'], controls]);

  return (
    <motion.div animate={controls} className="w-full h-full">
      {children}
    </motion.div>
  );
};

export default ShakeEffect;
